import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import { computed } from "vue";
import { useConfirm } from "primevue/useconfirm";
import ConfirmDialog from "primevue/confirmdialog";
import Button from "primevue/button";
export default /*#__PURE__*/ _defineComponent({
    __name: 'OneDeskButton',
    props: {
        withRadius: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        acceptCallback: { type: Function, default: undefined },
        rejectCallback: { type: Function, default: undefined },
        confirmMessage: { default: "Are you sure you want to proceed ?" },
        confirmGroup: { default: "" },
        icon: {},
        label: {},
        severity: { default: "primary" },
        class: {},
        outlined: { type: Boolean, default: false }
    },
    emits: ["click"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const confirm = useConfirm();
        const emit = __emit;
        const className = computed(() => {
            const startingClass = props.class ?? "" + "one-desk-button";
            return startingClass + (props.withRadius ? " one-desk-button-with-radius" : "");
        });
        const onButtonClick = () => {
            if (props.acceptCallback === undefined) {
                emit("click");
                return;
            }
            confirm.require({
                group: props.confirmGroup,
                message: props.confirmMessage,
                header: "Confirmation",
                icon: "pi pi-exclamation-triangle",
                accept: () => {
                    if (props.acceptCallback !== undefined)
                        props.acceptCallback();
                },
                reject: () => {
                    if (props.rejectCallback !== undefined)
                        props.rejectCallback();
                },
            });
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(Button), {
                    data: "",
                    onClick: onButtonClick,
                    class: _normalizeClass(className.value),
                    disabled: _ctx.disabled,
                    icon: _ctx.icon,
                    label: _ctx.label,
                    severity: _ctx.severity,
                    outlined: _ctx.outlined,
                    "data-testid": "one-desk-button"
                }, {
                    default: _withCtx(() => [
                        _renderSlot(_ctx.$slots, "default")
                    ]),
                    _: 3
                }, 8, ["class", "disabled", "icon", "label", "severity", "outlined"]),
                (_ctx.acceptCallback !== undefined)
                    ? (_openBlock(), _createBlock(_unref(ConfirmDialog), {
                        key: 0,
                        group: _ctx.confirmGroup
                    }, null, 8, ["group"]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
